export * from "./enterprise-contact-thanks.template";
export { EnterpriseContactThanksPageTemplate as default } from "./enterprise-contact-thanks.template";
